import Fade from "components/UI/Animations/Fade/Fade";
import BottomIcons from "components/UI/BottomIcons/BottomIcons";
import NavigationButtons from "components/UI/NavigationButtons/NavigationButtons";
import { ReactNode, useState } from "react";
import EndQuizModal from "routes/Quiz/components/EndQuizModal/EndQuizModal";
import styles from "./QuizLayout.module.scss";

interface QuizLayoutProps {
  title: string;
  titleAbsolute?: boolean;
  children: ReactNode;
  backSelected?: boolean;
  endQuizSelected: boolean;
  eventCounter: number;
  questionIndex: number;
  endQuizModal: boolean;
  setEndQuizModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function QuizLayout({
  title,
  children,
  backSelected,
  endQuizSelected,
  eventCounter,
  questionIndex,
  endQuizModal,
  setEndQuizModal,
  titleAbsolute,
}: QuizLayoutProps) {
  const [cancelEndQuiz, setCancelEndQuiz] = useState(false);

  return (
    <Fade>
      {endQuizModal ? (
        <EndQuizModal
          setCancelEndQuiz={setCancelEndQuiz}
          setEndQuizModal={setEndQuizModal}
          cancelEndQuiz={cancelEndQuiz}
        />
      ) : (
        <div className={styles.quizLayout}>
          <div className={styles.top}>
            <NavigationButtons
              backSelected={backSelected}
              endQuizSelected={endQuizSelected}
              questionIndex={questionIndex}
            />
          </div>
          <div className={styles.content}>
            <h1
              className={`${styles.title} ${titleAbsolute ? styles.absolute : ""}`}
            >
              {title}
            </h1>
            {children}
          </div>
          <BottomIcons eventCounter={eventCounter} />
        </div>
      )}
    </Fade>
  );
}
